import {
  SET_QUOTATION_ACTIVE_BILLING,
  SET_QUOTATION_ACTIVE_SHIPPING,
  SET_QUOTATION_CANCELLED,
  SET_QUOTATION_CART,
  SET_QUOTATION_CURRENCY,
  SET_QUOTATION_ENTERPRISE,
  SET_QUOTATION_FREE_DELIVERY,
  SET_QUOTATION_GST_WAIVED,
	SET_QUOTATION_USER,
  SET_QUOTATION_USER_NEW_ADDRESS,
  SET_QUOTATION_LAST_CONTACT,
  SET_QUOTATION_PAYMENT_OBJECT,
  SET_QUOTATION_PAYMENT_TERM_DAYS,
  SET_QUOTATION_PRODUCTS
} from './types';

const defaultState = {
  live: false,
  cart: {},
  user: {},
  enterprise: {},
  loading: false
}

export const quotationReducer = ( state = defaultState, action ) => {
  
  switch( action.type ){

		case SET_QUOTATION_ACTIVE_BILLING:
			return {
				...state,
				cart: {
					...state.cart,
					activeBilling: action.address
				}
			}
		
		case SET_QUOTATION_ACTIVE_SHIPPING:
			return {
				...state,
				cart: {
					...state.cart,
					activeShipping: action.address
				}
			}
    
    case SET_QUOTATION_CANCELLED:
      return {
        ...state,
        cart: {
          ...state.cart,
          cancelled:true,
          cancelledBy: action.cancelledBy
        }
      }

    case SET_QUOTATION_CART:{

      let punchoutCart = false;

      if(
        action.cart && 
        action.cart.paymentMethod === "credit" && 
        action.cart.user &&
        action.cart.user.punchoutId
      ){
        punchoutCart = true;
      }

      return {
        ...state,
        cart: {
          ...action.cart,
          punchoutCart
        }
      };
    }

    case SET_QUOTATION_CURRENCY:
      return {
        ...state,
        cart: {
          ...state.cart,
          currency: action.currency
        }
      }

    case SET_QUOTATION_ENTERPRISE:
      return {
        ...state, 
        enterprise: action.enterprise
      }

    case SET_QUOTATION_FREE_DELIVERY:
      return {
        ...state,
        cart: {
          ...state.cart,
          quoteAndForgetFreeDelivery: action.checked
        }
      }

    case SET_QUOTATION_GST_WAIVED:
      return {
        ...state,
        cart:{
          ...state.cart,
          quoteAndForgetGstWaived: action.checked
        }
      }

    case SET_QUOTATION_LAST_CONTACT:
      return {
        ...state,
        cart: {
          ...state.cart,
          lastContact: action.lastContact
        }
      }
    
    case SET_QUOTATION_USER:

      let activeBilling = {},
          activeShipping = {};

      if( state.cart.user && state.cart.user._id.toString() === action.user._id.toString() ){
        activeShipping = state.cart.activeShipping;
        activeBilling = state.cart.activeBilling;
      }

      return {
        ...state,
        cart: {
          ...state.cart,
          user: action.user,
          activeBilling,
          activeShipping
        }
      }
      
    case SET_QUOTATION_USER_NEW_ADDRESS:
      return {
        ...state,
        cart: {
          ...state.cart,
          user: {
            ...state.cart.user,
            addresses:[
              ...state.cart.user.addresses,
              action.address
            ]
          }
        }
      }

    case SET_QUOTATION_PAYMENT_OBJECT:
      return {
        ...state,
        cart: {
          ...state.cart,
          payment: action.payment
        }
      }
    
    case SET_QUOTATION_PAYMENT_TERM_DAYS:
      return {
        ...state,
        cart: {
          ...state.cart,
          paymentTermDays: action.paymentTermDays
        }
      }

    case SET_QUOTATION_PRODUCTS:
      return {
        ...state,
        cart:{
          ...state.cart,
          products: action.products
        }
      }
    
    default:
      return state;
    
  }
    
}


// WEBPACK FOOTER //
// ./src/components/quotation/reducers.js